import React from 'react';
import { Input } from '../ui/input';

const RevenueEditor = ({ data, onChange }) => {
  const updatePricing = (property, season, value) => {
    onChange({
      ...data,
      pricing: {
        ...data.pricing,
        [property]: {
          ...data.pricing[property],
          [season]: value
        }
      }
    });
  };

  return (
    <div className="bg-white rounded-lg p-6 space-y-6">
      <h2 className="text-2xl font-bold text-slate-900">Revenue Model</h2>

      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <h3 className="text-lg font-semibold mb-4">Villa Pricing</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium mb-1">Low Season</label>
              <Input value={data.pricing.villa.lowSeason} onChange={(e) => updatePricing('villa', 'lowSeason', e.target.value)} />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Mid Season</label>
              <Input value={data.pricing.villa.midSeason} onChange={(e) => updatePricing('villa', 'midSeason', e.target.value)} />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">High Season</label>
              <Input value={data.pricing.villa.highSeason} onChange={(e) => updatePricing('villa', 'highSeason', e.target.value)} />
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Farmhouse Pricing</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium mb-1">Low Season</label>
              <Input value={data.pricing.farmhouse.lowSeason} onChange={(e) => updatePricing('farmhouse', 'lowSeason', e.target.value)} />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Mid Season</label>
              <Input value={data.pricing.farmhouse.midSeason} onChange={(e) => updatePricing('farmhouse', 'midSeason', e.target.value)} />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">High Season</label>
              <Input value={data.pricing.farmhouse.highSeason} onChange={(e) => updatePricing('farmhouse', 'highSeason', e.target.value)} />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t pt-6">
        <h3 className="text-lg font-semibold mb-4">Occupancy</h3>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Projected Rate</label>
            <Input value={data.occupancy.rate} onChange={(e) => onChange({ ...data, occupancy: { ...data.occupancy, rate: e.target.value } })} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Description</label>
            <Input value={data.occupancy.description} onChange={(e) => onChange({ ...data, occupancy: { ...data.occupancy, description: e.target.value } })} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevenueEditor;
